import React, { memo } from 'react'
import { Control } from 'react-hook-form'
import ControlledSelect from 'transfix-form/components/ControlledSelect/ControlledSelect'
import AddIcon from 'transfix-icons/build/AddIcon'
import Button from 'transfix-ui/components/Button'
import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { makeStyles } from 'transfix-ui/core/styles'
import { IUseShipperFacilityState } from 'apps/marketplace/hooks/useShipperFacility/useShipperFacility'
import { IUseShipperFacilityVendorsState } from 'apps/marketplace/hooks/useShipperFacilityVendors/useShipperFacilityVendors'

export interface IVendorSectionProps {
  shipperFacilityState: IUseShipperFacilityState
  shipperFacilityVendorsState: IUseShipperFacilityVendorsState
  inputName: string
  errorMessage: string | undefined
  control: Control
}

const useStyles = makeStyles(() => ({
  hideVendors: {
    display: 'none',
  },
}))

const VendorSection = memo<IVendorSectionProps>(
  ({ control, errorMessage, inputName, shipperFacilityState, shipperFacilityVendorsState }) => {
    const classes = useStyles()
    const { facilityUuid = '', loading: loadingShipperFacility } = shipperFacilityState
    const {
      shipperFacilityVendorData = [],
      loaded: loadedShipperFacilityVendors,
    } = shipperFacilityVendorsState

    const vendorOptions: TSelectOpt[] = shipperFacilityVendorData.map(item => ({
      label: item.vendorName,
      value: item.vendorId,
    }))

    if (loadingShipperFacility) {
      return null
    }

    return (
      <div>
        <div>
          <a
            href={`${__ROOT__}/facilities/${facilityUuid}?modal=new-vendor-modal`}
            target='_blank'
            rel='noreferrer'>
            <Button startIcon={<AddIcon />} variant='text'>
              Add Vendor
            </Button>
          </a>
        </div>
        {loadedShipperFacilityVendors && !!vendorOptions.length && (
          <div className={vendorOptions.length === 1 ? classes.hideVendors : ''}>
            <ControlledSelect
              control={control}
              name={inputName}
              SelectProps={{
                label: 'Vendor',
                dataTest: 'vendor-select-field',
                options: vendorOptions,
                error: !!errorMessage,
                validationMessage: errorMessage,
              }}
            />
          </div>
        )}
      </div>
    )
  }
)

export default VendorSection
